import styled from 'styled-components';
import Hero from '../../images/hero.jpg';
import { isIE } from '../../utils/helper';

export const Header = styled.header`
  background-image: url(${Hero});
  background-size: cover;
  background-position: 0 70%;
  color: white;
  display: flex;
  flex-direction: column;
  height: 26rem;
  position: relative;
  ${() => isIE() ? `flex-shrink: 0;` :``}

  &:before {
    background-color: rgba(0, 0, 0, 0.3);
    content: '';
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Banner/styledComponents.js